var TagListDialogComponent = /** @class */ (function () {
    function TagListDialogComponent() {
        this.title = '';
        this.tags = [];
    }
    return TagListDialogComponent;
}());
export { TagListDialogComponent };
